export default __webpack_public_path__ + "static/media/1440 x 300 Backpacks Desktop.268297a5.jpg";